import type { MultiCallTransactionRequest, SimulatedRequest } from '@kwenta/sdk/types'
import { isSimulatedRequest, simulatedRequestToTxRequest } from '@kwenta/sdk/utils'
import { useCallback, useMemo } from 'react'
import { accountAbstractionFactory } from 'state/accountAbstraction'
import { selectOneClickTradingSelected } from 'state/futures/common/selectors'
import { selectAccountContext } from 'state/futures/selectors'
import { useAppSelector } from 'state/hooks'
import sdk from 'state/sdk'

export function usePrepareTransaction() {
	const { provider, network } = useAppSelector(selectAccountContext)
	const isOneClickReady = useAppSelector(selectOneClickTradingSelected)
	const accountAbstraction = useMemo(
		() => accountAbstractionFactory.getAccountAbstraction(provider),
		[provider]
	)

	const isUsingOneClick = useMemo(
		() => Boolean(accountAbstraction && isOneClickReady),
		[accountAbstraction, isOneClickReady]
	)

	const prepareTransaction = useCallback(
		async (request: SimulatedRequest | MultiCallTransactionRequest) => {
			if (isUsingOneClick) {
				return accountAbstraction!.prepareUserOp({
					simulateTxs: isSimulatedRequest(request) ? [request] : [],
					readyTxs: isSimulatedRequest(request) ? [] : [request],
				})
			}
			const tx = isSimulatedRequest(request) ? simulatedRequestToTxRequest(request) : request
			const gas = await sdk.transactions.estimateGas(tx, network)
			return { ...tx, ...gas }
		},
		[isUsingOneClick, accountAbstraction, network]
	)

	return { prepareTransaction }
}
